import React from 'react';

import ContactsFilterItem from '@components/ContactsSelector/Common/ContactsFilterItem';
import { useContactsSelector } from '@components/ContactsSelector/Common/ContactsSelectorContext';
import ModelFilterDrawerAgencySection from '@components/ContactsSelector/ModelsSelector/ModelFilterForm/ModelFilterDrawerAgencySection';
import ModelFilterDrawerFoldersSection from '@components/ContactsSelector/ModelsSelector/ModelFilterForm/ModelFilterDrawerFoldersSection';
import ModelFilterItemFeature from '@components/ContactsSelector/ModelsSelector/ModelFilterForm/ModelFilterItemFeature';
import { FilterRow, FilterLabel, FilterWrapper } from '@components/Filters/FilterRowUI';

import ContactsFilterItemCustomField from './ContactsFilterItemCustomField';

const FilterItemSelector = ({ filterItem }) => {
    switch (filterItem.source) {
        case 'filter':
            return <ContactsFilterItem key={filterItem.name} filter={filterItem} />;
        case 'customField':
            return <ContactsFilterItemCustomField key={filterItem.name} filter={filterItem} />;
        case 'feature':
            return <ModelFilterItemFeature key={filterItem.name} filter={filterItem} />;
        default:
            return <p>caso non trovato</p>;
    }
};

const ContactsFilterDrawerSections = () => {
    const { selection, global } = useContactsSelector();
    const { filters } = selection;

    const isFilterActive = (name) => {
        const filter = filters.working.find((f) => f.name === name);
        if (filter) {
            return true;
        }
        return false;
    };

    const section = global.filtersBySection.find((el) => el.areaID === filters.openSection);

    if (section.areaID.toLowerCase() === 'agency') {
        return <ModelFilterDrawerAgencySection section={section} />;
    } else if (section.areaID.toLowerCase() === 'folders') {
        return <ModelFilterDrawerFoldersSection />;
    } else {
        return (
            <div>
                {section.areaFilters.map((el, index) => (
                    <FilterRow key={el.index}>
                        <FilterLabel className={isFilterActive(el.name) ? 'active' : ''}>
                            {el.label}
                            {el.description && <small>{el.description}</small>}
                        </FilterLabel>
                        <FilterWrapper>
                            <FilterItemSelector filterItem={el} />
                        </FilterWrapper>
                    </FilterRow>
                ))}
            </div>
        );
    }
};

export default ContactsFilterDrawerSections;
